import {Modal} from 'react-bootstrap'
import ReactJson from 'react-json-view'

type Props = {
    title: string
    json: any
    isShow: boolean
    setShow: (param: boolean) => void
}

const ModalJsonView: React.FC<Props> = ({title, json, isShow, setShow}) => {
  return (
    <>
      <Modal
        show={isShow}
        onHide={() => {
          setShow(false)
        }}
        centered
        backdrop='static'
        scrollable
        size='lg'
      >
        <Modal.Header closeButton>
          <Modal.Title>{ title || 'Detail' }</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <ReactJson src={json} displayDataTypes={false} collapseStringsAfterLength={20}/>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default ModalJsonView
